export default __webpack_public_path__ + "static/media/icn-edit-pen.d24667d0.svg";